import React from 'react'

const PeopleTableIcon = () => {
  return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.16055 10.87C9.06055 10.86 8.94055 10.86 8.83055 10.87C6.45055 10.79 4.56055 8.84 4.56055 6.44C4.56055 3.99 6.54055 2 9.00055 2C11.4505 2 13.4405 3.99 13.4405 6.44C13.4305 8.84 11.5405 10.79 9.16055 10.87Z"
                stroke="#4C6FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M16.4093 4C18.3493 4 19.9093 5.57 19.9093 7.5C19.9093 9.39 18.4093 10.93 16.5393 11C16.4593 10.99 16.3693 10.99 16.2793 11"
                stroke="#4C6FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M4.1607 14.56C1.7407 16.18 1.7407 18.82 4.1607 20.43C6.9107 22.27 11.4207 22.27 14.1707 20.43C16.5907 18.81 16.5907 16.17 14.1707 14.56C11.4307 12.73 6.9207 12.73 4.1607 14.56Z"
                stroke="#4C6FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M18.3398 20C19.0598 19.85 19.7398 19.56 20.2998 19.13C21.8598 17.96 21.8598 16.03 20.2998 14.86C19.7498 14.44 19.0798 14.16 18.3698 14"
                stroke="#4C6FFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
  )
}

export default PeopleTableIcon
